<div id="cover-landing" class="text-white pt-5 overflow-hidden flex justify-center items-center position-relative">
  <div class="mt-1 lg:pt-[5rem]">
    <div class="container text-center px-5">
      <h3 class="capitalize font-bold py-10 text-center xl:text-5xl lg:text-4xl md:text-3xl text-2xl title">
        Why Students Trust Our Revision Notes

      </h3>

      <div class="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 flex-wrap justify-center  mx-2 ">
        <div class=" px-2 my-5">
          <h4 class="text-lg font-semibold mb-2 text-[#00EED0]">Revise More Efficiently</h4>
          <div class="rounded-xl border p-6 pb-0 h-full d-flex align-items-center ">

            <p class="text-sm leading-relaxed">
              Our notes break down every topic clearly and concisely, helping you focus on what
              matters most and make the most of your study time.
            </p>
          </div>
        </div>

        <div class=" px-2 my-5">
          <h4 class="text-lg font-semibold mb-2 text-[#00EED0]">Access Expert Knowledge</h4>
          <div class="rounded-xl border p-6 pb-0 h-full d-flex align-items-center ">

            <p class="text-sm leading-relaxed">
              Packed with examiner tips, key examples, and expert guidance, our notes give you the
              insights you need to tackle every question confidently</p>
          </div>
        </div>

        <div class=" px-2 my-5">
          <h4 class="text-lg font-semibold mb-2 text-[#00EED0]">Increase Confidence
          </h4>
          <div class="rounded-xl border p-6 pb-0 h-full d-flex align-items-center ">
            <p class="text-sm leading-relaxed ">
              With structured content and step-by-step explanations, our revision notes help you fill
              your learning gaps, reinforce understanding, and face the exams with utmost
              preparations. </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>